//# sourceMappingURL=input.mjs.map
/// <reference types="./input.d.mts" />
import * as $dynamic from "../../../gleam_stdlib/gleam/dynamic.mjs";
import * as $int from "../../../gleam_stdlib/gleam/int.mjs";
import * as $option from "../../../gleam_stdlib/gleam/option.mjs";
import { None, Some } from "../../../gleam_stdlib/gleam/option.mjs";
import * as $redraw from "../../../redraw/redraw.mjs";
import * as $event from "../../../redraw/redraw/event.mjs";
import * as $a from "../../../redraw_dom/redraw/dom/attribute.mjs";
import * as $focus from "../../../redraw_dom/redraw/dom/event/focus.mjs";
import * as $input from "../../../redraw_dom/redraw/dom/event/input.mjs";
import * as $keyboard from "../../../redraw_dom/redraw/dom/event/keyboard.mjs";
import * as $mouse from "../../../redraw_dom/redraw/dom/event/mouse.mjs";
import * as $e from "../../../redraw_dom/redraw/dom/events.mjs";
import * as $h from "../../../redraw_dom/redraw/dom/html.mjs";
import * as $css from "../../../sketch/sketch/css.mjs";
import * as $cy from "../../ds/cypress.mjs";
import * as $s from "../../ds/internals/styles/input.mjs";
import * as $position from "../../ds/position.mjs";
import { toList, CustomType as $CustomType } from "../../gleam.mjs";
import { blur, focus } from "./input.ffi.mjs";

export { blur, focus };

export class Props extends $CustomType {
  constructor(label, placeholder, type_, disabled, name, error, value, icon, on_input, on_submit, on_blur, on_keydown, multiline, rows, class$, id, enter_submit, submit_keep_focus, autofocus, data_test, min, max, step, size, position, resize, style, wrapper_style) {
    super();
    this.label = label;
    this.placeholder = placeholder;
    this.type_ = type_;
    this.disabled = disabled;
    this.name = name;
    this.error = error;
    this.value = value;
    this.icon = icon;
    this.on_input = on_input;
    this.on_submit = on_submit;
    this.on_blur = on_blur;
    this.on_keydown = on_keydown;
    this.multiline = multiline;
    this.rows = rows;
    this.class = class$;
    this.id = id;
    this.enter_submit = enter_submit;
    this.submit_keep_focus = submit_keep_focus;
    this.autofocus = autofocus;
    this.data_test = data_test;
    this.min = min;
    this.max = max;
    this.step = step;
    this.size = size;
    this.position = position;
    this.resize = resize;
    this.style = style;
    this.wrapper_style = wrapper_style;
  }
}
export const Props$Props = (label, placeholder, type_, disabled, name, error, value, icon, on_input, on_submit, on_blur, on_keydown, multiline, rows, class$, id, enter_submit, submit_keep_focus, autofocus, data_test, min, max, step, size, position, resize, style, wrapper_style) =>
  new Props(label,
  placeholder,
  type_,
  disabled,
  name,
  error,
  value,
  icon,
  on_input,
  on_submit,
  on_blur,
  on_keydown,
  multiline,
  rows,
  class$,
  id,
  enter_submit,
  submit_keep_focus,
  autofocus,
  data_test,
  min,
  max,
  step,
  size,
  position,
  resize,
  style,
  wrapper_style);
export const Props$isProps = (value) => value instanceof Props;
export const Props$Props$label = (value) => value.label;
export const Props$Props$0 = (value) => value.label;
export const Props$Props$placeholder = (value) => value.placeholder;
export const Props$Props$1 = (value) => value.placeholder;
export const Props$Props$type_ = (value) => value.type_;
export const Props$Props$2 = (value) => value.type_;
export const Props$Props$disabled = (value) => value.disabled;
export const Props$Props$3 = (value) => value.disabled;
export const Props$Props$name = (value) => value.name;
export const Props$Props$4 = (value) => value.name;
export const Props$Props$error = (value) => value.error;
export const Props$Props$5 = (value) => value.error;
export const Props$Props$value = (value) => value.value;
export const Props$Props$6 = (value) => value.value;
export const Props$Props$icon = (value) => value.icon;
export const Props$Props$7 = (value) => value.icon;
export const Props$Props$on_input = (value) => value.on_input;
export const Props$Props$8 = (value) => value.on_input;
export const Props$Props$on_submit = (value) => value.on_submit;
export const Props$Props$9 = (value) => value.on_submit;
export const Props$Props$on_blur = (value) => value.on_blur;
export const Props$Props$10 = (value) => value.on_blur;
export const Props$Props$on_keydown = (value) => value.on_keydown;
export const Props$Props$11 = (value) => value.on_keydown;
export const Props$Props$multiline = (value) => value.multiline;
export const Props$Props$12 = (value) => value.multiline;
export const Props$Props$rows = (value) => value.rows;
export const Props$Props$13 = (value) => value.rows;
export const Props$Props$class = (value) => value.class;
export const Props$Props$14 = (value) => value.class;
export const Props$Props$id = (value) => value.id;
export const Props$Props$15 = (value) => value.id;
export const Props$Props$enter_submit = (value) => value.enter_submit;
export const Props$Props$16 = (value) => value.enter_submit;
export const Props$Props$submit_keep_focus = (value) => value.submit_keep_focus;
export const Props$Props$17 = (value) => value.submit_keep_focus;
export const Props$Props$autofocus = (value) => value.autofocus;
export const Props$Props$18 = (value) => value.autofocus;
export const Props$Props$data_test = (value) => value.data_test;
export const Props$Props$19 = (value) => value.data_test;
export const Props$Props$min = (value) => value.min;
export const Props$Props$20 = (value) => value.min;
export const Props$Props$max = (value) => value.max;
export const Props$Props$21 = (value) => value.max;
export const Props$Props$step = (value) => value.step;
export const Props$Props$22 = (value) => value.step;
export const Props$Props$size = (value) => value.size;
export const Props$Props$23 = (value) => value.size;
export const Props$Props$position = (value) => value.position;
export const Props$Props$24 = (value) => value.position;
export const Props$Props$resize = (value) => value.resize;
export const Props$Props$25 = (value) => value.resize;
export const Props$Props$style = (value) => value.style;
export const Props$Props$26 = (value) => value.style;
export const Props$Props$wrapper_style = (value) => value.wrapper_style;
export const Props$Props$27 = (value) => value.wrapper_style;

export function value(text) {
  return new Props(
    new None(),
    new None(),
    "text",
    new None(),
    new None(),
    new None(),
    text,
    new None(),
    new None(),
    new None(),
    new None(),
    new None(),
    false,
    5,
    new None(),
    new None(),
    false,
    false,
    new None(),
    new None(),
    new None(),
    new None(),
    new None(),
    new $s.Medium(),
    new $position.Left(),
    false,
    new None(),
    new None(),
  );
}

export function name(props, name) {
  return new Props(
    props.label,
    props.placeholder,
    props.type_,
    props.disabled,
    new Some(name),
    props.error,
    props.value,
    props.icon,
    props.on_input,
    props.on_submit,
    props.on_blur,
    props.on_keydown,
    props.multiline,
    props.rows,
    props.class,
    props.id,
    props.enter_submit,
    props.submit_keep_focus,
    props.autofocus,
    props.data_test,
    props.min,
    props.max,
    props.step,
    props.size,
    props.position,
    props.resize,
    props.style,
    props.wrapper_style,
  );
}

export function label(props, text) {
  return new Props(
    new Some(text),
    props.placeholder,
    props.type_,
    props.disabled,
    props.name,
    props.error,
    props.value,
    props.icon,
    props.on_input,
    props.on_submit,
    props.on_blur,
    props.on_keydown,
    props.multiline,
    props.rows,
    props.class,
    props.id,
    props.enter_submit,
    props.submit_keep_focus,
    props.autofocus,
    props.data_test,
    props.min,
    props.max,
    props.step,
    props.size,
    props.position,
    props.resize,
    props.style,
    props.wrapper_style,
  );
}

export function placeholder(props, text) {
  return new Props(
    props.label,
    new Some(text),
    props.type_,
    props.disabled,
    props.name,
    props.error,
    props.value,
    props.icon,
    props.on_input,
    props.on_submit,
    props.on_blur,
    props.on_keydown,
    props.multiline,
    props.rows,
    props.class,
    props.id,
    props.enter_submit,
    props.submit_keep_focus,
    props.autofocus,
    props.data_test,
    props.min,
    props.max,
    props.step,
    props.size,
    props.position,
    props.resize,
    props.style,
    props.wrapper_style,
  );
}

export function type_(props, text) {
  return new Props(
    props.label,
    props.placeholder,
    text,
    props.disabled,
    props.name,
    props.error,
    props.value,
    props.icon,
    props.on_input,
    props.on_submit,
    props.on_blur,
    props.on_keydown,
    props.multiline,
    props.rows,
    props.class,
    props.id,
    props.enter_submit,
    props.submit_keep_focus,
    props.autofocus,
    props.data_test,
    props.min,
    props.max,
    props.step,
    props.size,
    props.position,
    props.resize,
    props.style,
    props.wrapper_style,
  );
}

export function disabled(props, value) {
  return new Props(
    props.label,
    props.placeholder,
    props.type_,
    new Some(value),
    props.name,
    props.error,
    props.value,
    props.icon,
    props.on_input,
    props.on_submit,
    props.on_blur,
    props.on_keydown,
    props.multiline,
    props.rows,
    props.class,
    props.id,
    props.enter_submit,
    props.submit_keep_focus,
    props.autofocus,
    props.data_test,
    props.min,
    props.max,
    props.step,
    props.size,
    props.position,
    props.resize,
    props.style,
    props.wrapper_style,
  );
}

export function error(props, value) {
  return new Props(
    props.label,
    props.placeholder,
    props.type_,
    props.disabled,
    props.name,
    new Some(value),
    props.value,
    props.icon,
    props.on_input,
    props.on_submit,
    props.on_blur,
    props.on_keydown,
    props.multiline,
    props.rows,
    props.class,
    props.id,
    props.enter_submit,
    props.submit_keep_focus,
    props.autofocus,
    props.data_test,
    props.min,
    props.max,
    props.step,
    props.size,
    props.position,
    props.resize,
    props.style,
    props.wrapper_style,
  );
}

export function icon(props, value) {
  return new Props(
    props.label,
    props.placeholder,
    props.type_,
    props.disabled,
    props.name,
    props.error,
    props.value,
    new Some(value),
    props.on_input,
    props.on_submit,
    props.on_blur,
    props.on_keydown,
    props.multiline,
    props.rows,
    props.class,
    props.id,
    props.enter_submit,
    props.submit_keep_focus,
    props.autofocus,
    props.data_test,
    props.min,
    props.max,
    props.step,
    props.size,
    props.position,
    props.resize,
    props.style,
    props.wrapper_style,
  );
}

export function icon_position(props, position) {
  return new Props(
    props.label,
    props.placeholder,
    props.type_,
    props.disabled,
    props.name,
    props.error,
    props.value,
    props.icon,
    props.on_input,
    props.on_submit,
    props.on_blur,
    props.on_keydown,
    props.multiline,
    props.rows,
    props.class,
    props.id,
    props.enter_submit,
    props.submit_keep_focus,
    props.autofocus,
    props.data_test,
    props.min,
    props.max,
    props.step,
    props.size,
    position,
    props.resize,
    props.style,
    props.wrapper_style,
  );
}

function view_error(props) {
  let $ = props.error;
  if ($ instanceof Some) {
    let error$1 = $[0];
    return $s.error_label(toList([]), toList([$h.text(error$1)]));
  } else {
    return $h.none();
  }
}

function unwrap_attribute(attribute, mapper) {
  let _pipe = attribute;
  let _pipe$1 = $option.map(_pipe, mapper);
  return $option.lazy_unwrap(_pipe$1, $a.none);
}

function submit(event, on_submit, keep_focus) {
  let _block;
  let _pipe = event;
  let _pipe$1 = $keyboard.as_event(_pipe);
  let _pipe$2 = $event.prevent_default(_pipe$1);
  _block = $event.target(_pipe$2);
  let target = _block;
  if (keep_focus) {
    focus(target);
  } else {
    blur(target);
  }
  return on_submit();
}

function on_enter_keydown(props) {
  let $ = props.on_keydown;
  let $1 = props.on_submit;
  if ($ instanceof Some) {
    if ($1 instanceof Some) {
      return $a.none();
    } else {
      return $a.none();
    }
  } else if ($1 instanceof Some) {
    let on_submit$1 = $1[0];
    return $e.on_key_down(
      (event) => {
        let meta = $keyboard.meta_key(event);
        let shift = $keyboard.shift_key(event);
        let key = $keyboard.key(event);
        let $2 = props.enter_submit;
        if ($2) {
          if (shift) {
            if (key === "Enter") {
              return undefined;
            } else {
              return undefined;
            }
          } else if (meta) {
            if (key === "Enter") {
              return undefined;
            } else {
              return undefined;
            }
          } else if (key === "Enter") {
            return submit(event, on_submit$1, props.submit_keep_focus);
          } else {
            return undefined;
          }
        } else if (meta && key === "Enter") {
          return submit(event, on_submit$1, props.submit_keep_focus);
        } else {
          return undefined;
        }
      },
    );
  } else {
    return $a.none();
  }
}

function on_user_keydown(props) {
  return unwrap_attribute(
    props.on_keydown,
    (handler) => {
      return $e.on_key_down((event) => { return handler(event); });
    },
  );
}

function keep_focus_on_icon_press(props) {
  let $ = props.submit_keep_focus;
  if ($) {
    return $e.on_mouse_down(
      (mouse_event) => {
        let _pipe = mouse_event;
        let _pipe$1 = $mouse.as_event(_pipe);
        $event.prevent_default(_pipe$1);
        return undefined;
      },
    );
  } else {
    return $a.none();
  }
}

function on_input_submit(props) {
  let skip_events = props.value === "";
  let $ = props.on_submit;
  if ($ instanceof Some) {
    if (skip_events) {
      return $a.none();
    } else {
      let handler = $[0];
      return $e.on_click((_) => { return handler(); });
    }
  } else {
    return $a.none();
  }
}

function input_icon(props) {
  let $ = props.icon;
  if ($ instanceof Some) {
    let icon$1 = $[0];
    let capture_events = props.value !== "";
    return $s.icon_display_wrapper(
      capture_events,
      toList([on_input_submit(props), keep_focus_on_icon_press(props)]),
      toList([$s.icon_display(props.size, toList([]), icon$1)]),
    );
  } else {
    return $h.none();
  }
}

function select_input_class(props) {
  let $ = props.multiline;
  let $1 = props.disabled;
  let $2 = props.error;
  if ($) {
    if ($1 instanceof Some) {
      let $3 = $1[0];
      if ($3) {
        return [
          (size, c, attrs) => {
            return $s.disabled_multiline(size, c, props.resize, attrs);
          },
          new $s.Disabled(),
        ];
      } else if ($2 instanceof Some) {
        return [
          (size, c, attrs) => {
            return $s.error_multiline(size, c, props.resize, attrs);
          },
          new $s.Error(),
        ];
      } else {
        return [
          (size, c, attrs) => {
            return $s.standard_multiline(size, c, props.resize, attrs);
          },
          new $s.Standard(),
        ];
      }
    } else if ($2 instanceof Some) {
      return [
        (size, c, attrs) => {
          return $s.error_multiline(size, c, props.resize, attrs);
        },
        new $s.Error(),
      ];
    } else {
      return [
        (size, c, attrs) => {
          return $s.standard_multiline(size, c, props.resize, attrs);
        },
        new $s.Standard(),
      ];
    }
  } else if ($1 instanceof Some) {
    let $3 = $1[0];
    if ($3) {
      return [$s.disabled, new $s.Disabled()];
    } else if ($2 instanceof Some) {
      return [$s.error, new $s.Error()];
    } else {
      return [$s.standard, new $s.Standard()];
    }
  } else if ($2 instanceof Some) {
    return [$s.error, new $s.Error()];
  } else {
    return [$s.standard, new $s.Standard()];
  }
}

function view_content(props) {
  let $ = select_input_class(props);
  let input$1 = $[0];
  let state = $[1];
  let data = unwrap_attribute(props.data_test, $cy.data);
  return $s.input_wrapper(
    state,
    props.position,
    props.size,
    props.wrapper_style,
    toList([data]),
    toList([
      input_icon(props),
      input$1(
        props.size,
        props.style,
        toList([
          $a.type_(props.type_),
          $a.value(props.value),
          on_user_keydown(props),
          on_enter_keydown(props),
          unwrap_attribute(props.min, $a.min),
          unwrap_attribute(props.max, $a.max),
          unwrap_attribute(props.disabled, $a.disabled),
          unwrap_attribute(props.id, $a.id),
          unwrap_attribute(props.autofocus, $a.auto_focus),
          unwrap_attribute(props.class, $a.class$),
          unwrap_attribute(props.placeholder, $a.placeholder),
          unwrap_attribute(props.on_input, $e.on_input),
          unwrap_attribute(props.on_blur, $e.on_blur),
          unwrap_attribute(props.name, $a.name),
          unwrap_attribute(props.step, $a.step),
          (() => {
            let $1 = props.multiline;
            if ($1) {
              return $a.attribute("rows", $int.to_string(props.rows));
            } else {
              return $a.none();
            }
          })(),
        ]),
      ),
    ]),
  );
}

export function input(props) {
  let content = view_content(props);
  let error$1 = view_error(props);
  return $s.wrapper(
    toList([$cy.data("input-wrap")]),
    (() => {
      let $ = props.label;
      if ($ instanceof Some) {
        let label$1 = $[0];
        return toList([$h.text(label$1), content, error$1]);
      } else {
        return toList([content, error$1]);
      }
    })(),
  );
}

export function on_input(props, handler) {
  return new Props(
    props.label,
    props.placeholder,
    props.type_,
    props.disabled,
    props.name,
    props.error,
    props.value,
    props.icon,
    new Some(
      (event) => {
        handler($input.value(event));
        return undefined;
      },
    ),
    props.on_submit,
    props.on_blur,
    props.on_keydown,
    props.multiline,
    props.rows,
    props.class,
    props.id,
    props.enter_submit,
    props.submit_keep_focus,
    props.autofocus,
    props.data_test,
    props.min,
    props.max,
    props.step,
    props.size,
    props.position,
    props.resize,
    props.style,
    props.wrapper_style,
  );
}

export function on_submit(props, handler) {
  return new Props(
    props.label,
    props.placeholder,
    props.type_,
    props.disabled,
    props.name,
    props.error,
    props.value,
    props.icon,
    props.on_input,
    new Some(
      () => {
        handler();
        return undefined;
      },
    ),
    props.on_blur,
    props.on_keydown,
    props.multiline,
    props.rows,
    props.class,
    props.id,
    props.enter_submit,
    props.submit_keep_focus,
    props.autofocus,
    props.data_test,
    props.min,
    props.max,
    props.step,
    props.size,
    props.position,
    props.resize,
    props.style,
    props.wrapper_style,
  );
}

export function on_blur(props, handler) {
  return new Props(
    props.label,
    props.placeholder,
    props.type_,
    props.disabled,
    props.name,
    props.error,
    props.value,
    props.icon,
    props.on_input,
    props.on_submit,
    new Some(
      (_) => {
        handler();
        return undefined;
      },
    ),
    props.on_keydown,
    props.multiline,
    props.rows,
    props.class,
    props.id,
    props.enter_submit,
    props.submit_keep_focus,
    props.autofocus,
    props.data_test,
    props.min,
    props.max,
    props.step,
    props.size,
    props.position,
    props.resize,
    props.style,
    props.wrapper_style,
  );
}

/**
 * Be careful, on_keydown takes precedence over enter_submit and on_submit.
 * Accepts the whole event and the key pressed.
 */
export function on_keydown(props, handler) {
  return new Props(
    props.label,
    props.placeholder,
    props.type_,
    props.disabled,
    props.name,
    props.error,
    props.value,
    props.icon,
    props.on_input,
    props.on_submit,
    props.on_blur,
    new Some(
      (event) => {
        handler(event);
        return undefined;
      },
    ),
    props.multiline,
    props.rows,
    props.class,
    props.id,
    props.enter_submit,
    props.submit_keep_focus,
    props.autofocus,
    props.data_test,
    props.min,
    props.max,
    props.step,
    props.size,
    props.position,
    props.resize,
    props.style,
    props.wrapper_style,
  );
}

export function multiline(props, value) {
  return new Props(
    props.label,
    props.placeholder,
    props.type_,
    props.disabled,
    props.name,
    props.error,
    props.value,
    props.icon,
    props.on_input,
    props.on_submit,
    props.on_blur,
    props.on_keydown,
    value,
    props.rows,
    props.class,
    props.id,
    props.enter_submit,
    props.submit_keep_focus,
    props.autofocus,
    props.data_test,
    props.min,
    props.max,
    props.step,
    props.size,
    props.position,
    props.resize,
    props.style,
    props.wrapper_style,
  );
}

export function rows(props, value) {
  return new Props(
    props.label,
    props.placeholder,
    props.type_,
    props.disabled,
    props.name,
    props.error,
    props.value,
    props.icon,
    props.on_input,
    props.on_submit,
    props.on_blur,
    props.on_keydown,
    props.multiline,
    value,
    props.class,
    props.id,
    props.enter_submit,
    props.submit_keep_focus,
    props.autofocus,
    props.data_test,
    props.min,
    props.max,
    props.step,
    props.size,
    props.position,
    props.resize,
    props.style,
    props.wrapper_style,
  );
}

export function enter_submit(props, value) {
  return new Props(
    props.label,
    props.placeholder,
    props.type_,
    props.disabled,
    props.name,
    props.error,
    props.value,
    props.icon,
    props.on_input,
    props.on_submit,
    props.on_blur,
    props.on_keydown,
    props.multiline,
    props.rows,
    props.class,
    props.id,
    value,
    props.submit_keep_focus,
    props.autofocus,
    props.data_test,
    props.min,
    props.max,
    props.step,
    props.size,
    props.position,
    props.resize,
    props.style,
    props.wrapper_style,
  );
}

export function submit_keep_focus(props, value) {
  return new Props(
    props.label,
    props.placeholder,
    props.type_,
    props.disabled,
    props.name,
    props.error,
    props.value,
    props.icon,
    props.on_input,
    props.on_submit,
    props.on_blur,
    props.on_keydown,
    props.multiline,
    props.rows,
    props.class,
    props.id,
    props.enter_submit,
    value,
    props.autofocus,
    props.data_test,
    props.min,
    props.max,
    props.step,
    props.size,
    props.position,
    props.resize,
    props.style,
    props.wrapper_style,
  );
}

/**
 * Focuses the input when it is first rendered.
 */
export function autofocus(props, value) {
  return new Props(
    props.label,
    props.placeholder,
    props.type_,
    props.disabled,
    props.name,
    props.error,
    props.value,
    props.icon,
    props.on_input,
    props.on_submit,
    props.on_blur,
    props.on_keydown,
    props.multiline,
    props.rows,
    props.class,
    props.id,
    props.enter_submit,
    props.submit_keep_focus,
    new Some(value),
    props.data_test,
    props.min,
    props.max,
    props.step,
    props.size,
    props.position,
    props.resize,
    props.style,
    props.wrapper_style,
  );
}

export function id(props, id) {
  return new Props(
    props.label,
    props.placeholder,
    props.type_,
    props.disabled,
    props.name,
    props.error,
    props.value,
    props.icon,
    props.on_input,
    props.on_submit,
    props.on_blur,
    props.on_keydown,
    props.multiline,
    props.rows,
    props.class,
    new Some(id),
    props.enter_submit,
    props.submit_keep_focus,
    props.autofocus,
    props.data_test,
    props.min,
    props.max,
    props.step,
    props.size,
    props.position,
    props.resize,
    props.style,
    props.wrapper_style,
  );
}

export function class$(props, name) {
  return new Props(
    props.label,
    props.placeholder,
    props.type_,
    props.disabled,
    props.name,
    props.error,
    props.value,
    props.icon,
    props.on_input,
    props.on_submit,
    props.on_blur,
    props.on_keydown,
    props.multiline,
    props.rows,
    new Some(name),
    props.id,
    props.enter_submit,
    props.submit_keep_focus,
    props.autofocus,
    props.data_test,
    props.min,
    props.max,
    props.step,
    props.size,
    props.position,
    props.resize,
    props.style,
    props.wrapper_style,
  );
}

export function data_test(props, content) {
  return new Props(
    props.label,
    props.placeholder,
    props.type_,
    props.disabled,
    props.name,
    props.error,
    props.value,
    props.icon,
    props.on_input,
    props.on_submit,
    props.on_blur,
    props.on_keydown,
    props.multiline,
    props.rows,
    props.class,
    props.id,
    props.enter_submit,
    props.submit_keep_focus,
    props.autofocus,
    new Some(content),
    props.min,
    props.max,
    props.step,
    props.size,
    props.position,
    props.resize,
    props.style,
    props.wrapper_style,
  );
}

export function min(props, content) {
  return new Props(
    props.label,
    props.placeholder,
    props.type_,
    props.disabled,
    props.name,
    props.error,
    props.value,
    props.icon,
    props.on_input,
    props.on_submit,
    props.on_blur,
    props.on_keydown,
    props.multiline,
    props.rows,
    props.class,
    props.id,
    props.enter_submit,
    props.submit_keep_focus,
    props.autofocus,
    props.data_test,
    new Some(content),
    props.max,
    props.step,
    props.size,
    props.position,
    props.resize,
    props.style,
    props.wrapper_style,
  );
}

export function max(props, content) {
  return new Props(
    props.label,
    props.placeholder,
    props.type_,
    props.disabled,
    props.name,
    props.error,
    props.value,
    props.icon,
    props.on_input,
    props.on_submit,
    props.on_blur,
    props.on_keydown,
    props.multiline,
    props.rows,
    props.class,
    props.id,
    props.enter_submit,
    props.submit_keep_focus,
    props.autofocus,
    props.data_test,
    props.min,
    new Some(content),
    props.step,
    props.size,
    props.position,
    props.resize,
    props.style,
    props.wrapper_style,
  );
}

export function step(props, content) {
  return new Props(
    props.label,
    props.placeholder,
    props.type_,
    props.disabled,
    props.name,
    props.error,
    props.value,
    props.icon,
    props.on_input,
    props.on_submit,
    props.on_blur,
    props.on_keydown,
    props.multiline,
    props.rows,
    props.class,
    props.id,
    props.enter_submit,
    props.submit_keep_focus,
    props.autofocus,
    props.data_test,
    props.min,
    props.max,
    new Some(content),
    props.size,
    props.position,
    props.resize,
    props.style,
    props.wrapper_style,
  );
}

export function small(props) {
  return new Props(
    props.label,
    props.placeholder,
    props.type_,
    props.disabled,
    props.name,
    props.error,
    props.value,
    props.icon,
    props.on_input,
    props.on_submit,
    props.on_blur,
    props.on_keydown,
    props.multiline,
    props.rows,
    props.class,
    props.id,
    props.enter_submit,
    props.submit_keep_focus,
    props.autofocus,
    props.data_test,
    props.min,
    props.max,
    props.step,
    new $s.Small(),
    props.position,
    props.resize,
    props.style,
    props.wrapper_style,
  );
}

export function xs(props) {
  return new Props(
    props.label,
    props.placeholder,
    props.type_,
    props.disabled,
    props.name,
    props.error,
    props.value,
    props.icon,
    props.on_input,
    props.on_submit,
    props.on_blur,
    props.on_keydown,
    props.multiline,
    props.rows,
    props.class,
    props.id,
    props.enter_submit,
    props.submit_keep_focus,
    props.autofocus,
    props.data_test,
    props.min,
    props.max,
    props.step,
    new $s.Xs(),
    props.position,
    props.resize,
    props.style,
    props.wrapper_style,
  );
}

export function medium(props) {
  return new Props(
    props.label,
    props.placeholder,
    props.type_,
    props.disabled,
    props.name,
    props.error,
    props.value,
    props.icon,
    props.on_input,
    props.on_submit,
    props.on_blur,
    props.on_keydown,
    props.multiline,
    props.rows,
    props.class,
    props.id,
    props.enter_submit,
    props.submit_keep_focus,
    props.autofocus,
    props.data_test,
    props.min,
    props.max,
    props.step,
    new $s.Medium(),
    props.position,
    props.resize,
    props.style,
    props.wrapper_style,
  );
}

export function resize(props, resize) {
  return new Props(
    props.label,
    props.placeholder,
    props.type_,
    props.disabled,
    props.name,
    props.error,
    props.value,
    props.icon,
    props.on_input,
    props.on_submit,
    props.on_blur,
    props.on_keydown,
    props.multiline,
    props.rows,
    props.class,
    props.id,
    props.enter_submit,
    props.submit_keep_focus,
    props.autofocus,
    props.data_test,
    props.min,
    props.max,
    props.step,
    props.size,
    props.position,
    resize,
    props.style,
    props.wrapper_style,
  );
}

export function style(props, style) {
  let style$1 = new Some(style);
  return new Props(
    props.label,
    props.placeholder,
    props.type_,
    props.disabled,
    props.name,
    props.error,
    props.value,
    props.icon,
    props.on_input,
    props.on_submit,
    props.on_blur,
    props.on_keydown,
    props.multiline,
    props.rows,
    props.class,
    props.id,
    props.enter_submit,
    props.submit_keep_focus,
    props.autofocus,
    props.data_test,
    props.min,
    props.max,
    props.step,
    props.size,
    props.position,
    props.resize,
    style$1,
    props.wrapper_style,
  );
}

export function wrapper_style(props, wrapper_style) {
  return new Props(
    props.label,
    props.placeholder,
    props.type_,
    props.disabled,
    props.name,
    props.error,
    props.value,
    props.icon,
    props.on_input,
    props.on_submit,
    props.on_blur,
    props.on_keydown,
    props.multiline,
    props.rows,
    props.class,
    props.id,
    props.enter_submit,
    props.submit_keep_focus,
    props.autofocus,
    props.data_test,
    props.min,
    props.max,
    props.step,
    props.size,
    props.position,
    props.resize,
    props.style,
    new Some(wrapper_style),
  );
}
